import { React, useEffect, useRef } from 'react';
import {
    Box,
    Grid,
    InputAdornment,
    TextField,
    Select,
    MenuItem
} from '@mui/material';

import FlowCellSelect from './FlowCellSelect';
import SequencerSelect from './SequencerSelect';
import BarcodingKitSelect from './BarcodingKitSelect';
import PrepKitSelect from './PrepKitSelect';

import { sequencerSerialNumberMetadata, stripSequencerSerialNumberPrefix, getFlowCellSerialNumberPrefixOptions, stripFlowCellSerialNumberPrefix, getFlowCellSerialNumberPrefix } from './canonicalizeMetadata';


function CreateONTRunForm(props) {
    const {
        sequencer,
        setSequencer,
        sequencerSerialNumber,
        setSequencerSerialNumber,
        sequencerSerialNumberIsValid,
        flowCell,
        setFlowCell,
        flowCellSerialNumber,
        flowCellSerialNumberIsValid,
        setFlowCellSerialNumber,
        barcodingKit,
        setBarcodingKit,
        libraryPrepKit,
        setLibraryPrepKit,
        platform,
        flowCellPrefix,
        setFlowCellPrefix
    } = props;

    const sequencerIsset = sequencer !== '' && sequencer !== 'unknown';
    const sequencerSerialNumberContent = (
        <TextField
            error={sequencerIsset && !sequencerSerialNumberIsValid}
            placeholder={sequencerSerialNumberMetadata[sequencer] ? sequencerSerialNumberMetadata[sequencer].placeholder : null}
            helperText={!sequencerIsset ? null : "Optional"}
            variant="standard"
            fullWidth
            label="Serial Number"
            value={stripSequencerSerialNumberPrefix(sequencerSerialNumber)}
            onChange={(event) => {
                setSequencerSerialNumber(event.target.value.toUpperCase());
            }}
            disabled={!sequencerIsset}
            slotProps={{
                input: {
                    startAdornment: <InputAdornment position="start">{sequencerSerialNumberMetadata[sequencer] ? sequencerSerialNumberMetadata[sequencer].prefix : null}</InputAdornment>
                }
            }}
        />
    )

    const flowCellIsset = flowCell !== '' && flowCell !== 'unknown';
    const prevFlowCellRef = useRef(null);

    useEffect(() => {
        if (!flowCellIsset) return;
        const havePrefixOptionsChanged = JSON.stringify(getFlowCellSerialNumberPrefixOptions(flowCell)) !== JSON.stringify(getFlowCellSerialNumberPrefixOptions(prevFlowCellRef.current));

        if (havePrefixOptionsChanged) {
            const flowCellSerialNumberPrefix = getFlowCellSerialNumberPrefix(flowCell, flowCellSerialNumber)
            setFlowCellPrefix(flowCellSerialNumberPrefix);
    
            prevFlowCellRef.current = flowCell;
        }
        
    }, [flowCell, flowCellIsset, flowCellSerialNumber, setFlowCellPrefix]);

    const FlowCellPrefixSelector = ({ flowCellIsset, flowCell, flowCellPrefix, setFlowCellPrefix }) => {
        if (!flowCellIsset) return null;
        const prefixOptions = getFlowCellSerialNumberPrefixOptions(flowCell);
        const showDropdown = prefixOptions.length > 1;
    
        if (showDropdown) {
            return (
                <Select 
                    value={flowCellPrefix} 
                    onChange={(e) => setFlowCellPrefix(e.target.value)}
                    variant="standard"
                    sx={{ minWidth: '60px', color: 'text.secondary' }}
                >
                    {prefixOptions.map(prefix => (
                        <MenuItem key={prefix} value={prefix}>{prefix}</MenuItem>
                    ))}
                </Select>
            );
        }
    
        return flowCellPrefix;
    };

    const flowCellSerialNumberContent = (
        <TextField
            error={flowCellIsset && !flowCellSerialNumberIsValid}
            placeholder={!flowCellIsset ? null : 'X12345'}
            helperText={!flowCellIsset ? null : "Optional"}
            variant="standard"
            fullWidth
            label="Serial Number"
            value={stripFlowCellSerialNumberPrefix(flowCellSerialNumber)}
            disabled={!flowCellIsset}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <FlowCellPrefixSelector 
                                flowCellIsset={flowCellIsset}
                                flowCell={flowCell}
                                flowCellPrefix={flowCellPrefix}
                                setFlowCellPrefix={setFlowCellPrefix}
                            />
                        </InputAdornment>
                    )
                }
            }}
            onChange={(event) => {
                setFlowCellSerialNumber(event.target.value.toUpperCase());
            }}
        />
    );

    return (
        <>
            <Grid item xs={6}>
                <Box sx={{padding: "15px 10px"}}>
                    <SequencerSelect sequencer={sequencer} setSequencer={setSequencer} platform={platform} /> 
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box sx={{padding: "15px 5px"}}>
                    {sequencerSerialNumberContent}
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box sx={{padding: "15px 10px"}}>
                    <FlowCellSelect flowCell={flowCell} setFlowCell={setFlowCell} platform={platform} />
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box sx={{padding: "15px 5px"}}>
                    {flowCellSerialNumberContent}
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box sx={{padding: "15px 10px"}}>
                    <BarcodingKitSelect barcodingKit={barcodingKit} setBarcodingKit={setBarcodingKit} platform={platform} />
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box sx={{padding: "15px 10px"}}>
                    <PrepKitSelect libraryPrepKit={libraryPrepKit} setLibraryPrepKit={setLibraryPrepKit} platform={platform} />
                </Box>
            </Grid>
            </>
    )
}

export default CreateONTRunForm;